import TimeSliderController from "../../app/TimeSliderController";
import store from "../../app/store";
import SatelliteAnimation from "./SatelliteAnimation";
import satLayer from "./tileSatLayerIntance";
import ObsTimeSliderController from "../../app/ObsTimeSliderController";

class SatelliteTimeSliderController extends ObsTimeSliderController{

    constructor(view, animation) {

        super(view, animation);
        store.on("satelliteCalendar", this.update.bind(this));

        this.animation.on("timeAnimationPrintTs", function(timestamp){
            const calendar = store.get("satelliteCalendar");
            this.view.setProgressText(calendar.ts2hour(new Date(timestamp)));
        }.bind(this));

        this.animation.on("timeAnimationStart", function(){
            this.view.enablePlayBar();
        }.bind(this));

        this.animation.on("timeAnimationStop", function(){
            this.view.disablePlayBar();
        }.bind(this));

        this.animation.on("timeAnimationPercent", function(progress){
            this.view.setProgressPercent(progress);
        }.bind(this));

        store.on("satelliteRange", function (value){
            this.animation.setTimeRange(value);
        }.bind(this));

    }

    createAnimation(){
        return new SatelliteAnimation(satLayer);
    }

    getTimestamp(){
        return store.get("satelliteTimestamp");
    }

    setTimestamp(timestamp){
        store.set("satelliteTimestamp", timestamp);
    }

    registerTimestampEvent(){
        store.on("satelliteTimestamp",  this.updateTimestampView.bind(this));
    }

    updateTimestampView(ts){
        const nslot = this.calendar.indxBestTs(ts);
        this.view.changeSlot(nslot);
        this.view.setDayText(this.calendar.ts2day(this.calendar.timestamps[nslot]));
        this.view.setHourText(this.calendar.ts2hour(this.calendar.timestamps[nslot]));
    }


    pushEvent(){
        // dataLayer.push({
        //     'ga4_action_name': 'visor_playmovie',
        //     'ga4_tag_name': 'click'
        // })
    }

}

export default SatelliteTimeSliderController;
